import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
  appRequestSelector,
  uownSessionIdSelector,
  blackboxIdSelector,
  koalafiNeuroIdSelector
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";
import { selectedOfferSelector } from '../../../selectors';
import Form from "./Form";

import "./styles.scss";

class UownBankDataForm extends Component {

  state = {
    additionalData: {},
    valid: false
  }

  buildBodyToInitApplication = () => {
    const { additionalData } = this.state;
    const { appRequest, selectedOffer, uownSessionId, blackboxId, koalafiNeuroId } = this.props;

    const applicationRequest = this.props.offer
    applicationRequest.has_additional_info = true;
    applicationRequest.additional_info_data = {};
    if(additionalData.routingNum && additionalData.accountNum && additionalData.cardBin){
      applicationRequest.bank_data_is_required = false;
      applicationRequest.additional_info_data.bankAccount = {
        routing: additionalData.routingNum,
        account: additionalData.accountNum,
        type: 'checking',
        cardBin: additionalData.cardBin
      }
    }

    return {
      ...applicationRequest,
      personalInfo: appRequest.personalInfo,
      residenceInfo: appRequest.residenceInfo,
      employmentInformation: appRequest.employmentInformation,
      // device / behavioral session ids live at the leaseForm root, not in applicationRequest
      uownSessionId,
      blackboxId,
      koalafi_neuro_id: koalafiNeuroId
    };
  }
  
  submitForm = (e) => {
    const { valid } = this.state;
    e.preventDefault();
    if (valid) {
      this.props.selectOffer({selectedOffer: this.buildBodyToInitApplication()});
    }
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid
    });
  }

  render() {
    const { loading, activeStepData } = this.props;
    const { valid } = this.state;

    return (
      <div className="paypair-step-content">
        <div className="uown-bank-data-form-container">
          <div className="uown-bank-data-form">
            <div className="uown-bank-data-form__body">
              {activeStepData.error && activeStepData.message && (
                <div className="uown-bank-data-form__error-message">
                  {activeStepData.message || ''}
                </div>
              )}

              <Form
                onDataChange={this.setAdditionalData}
              />
            </div>

            <div className="uown-bank-data-form__footer">
              <BlueBtn
                disabled={!valid}
                loading={loading}
                onClick={this.submitForm}
              >
                Submit
              </BlueBtn>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  selectedOffer: selectedOfferSelector()(state),
  activeStepData: activeStepDataSelector()(state),
  appRequest: appRequestSelector()(state),
  uownSessionId: uownSessionIdSelector()(state),
  blackboxId: blackboxIdSelector()(state),
  koalafiNeuroId: koalafiNeuroIdSelector()(state)
});

const mapDistpatchToProps = dispatch => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data))
  };
};

UownBankDataForm = connect(
  mapStateToProps,
  mapDistpatchToProps
)(UownBankDataForm);

export default UownBankDataForm;
